module.exports = __webpack_public_path__ + "web/img/tpsn_status_10.895396eb.png";